import { render, staticRenderFns } from "./MaterialsMaintenance.vue?vue&type=template&id=744ceb56&"
import script from "./MaterialsMaintenance.vue?vue&type=script&lang=js&"
export * from "./MaterialsMaintenance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('744ceb56')) {
      api.createRecord('744ceb56', component.options)
    } else {
      api.reload('744ceb56', component.options)
    }
    module.hot.accept("./MaterialsMaintenance.vue?vue&type=template&id=744ceb56&", function () {
      api.rerender('744ceb56', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/global/materialsRequests/components/MaterialsMaintenance.vue"
export default component.exports